import React from "react";
import {
    Route,
    Routes as Switch
} from "react-router-dom";
import Home from '../Pages/Home';
import VerificationWizard from '../Pages/VerificationWizard';
import Success from '../Pages/Success';

export const routes = [
    {
        path: "/",
        element: <Home />,
        exact: true
    },
    {
        path: "/verify",
        element: <VerificationWizard />,
        exact: true
    },
    {
        path: "/success",
        element: <Success />,
        exact: true
    }
];

const Routes = () => {
    return (
        <Switch>
            {routes.map(({ ...route }, i) => (
                <Route key={i} {...route} />
            ))}
            <Route path="*" element={<Home />} />
        </Switch>
    );
};

export default Routes;
